// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { RoadNetworkAreaId } from './RoadNetworkAreaId'
import { RoadNetworkAreaNavigation } from './RoadNetworkAreaNavigation'
import { RoadNetworkAreaRoutes } from './RoadNetworkAreaRoutes'

const LazyRoadNetworkComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./RoadNetworkArea')),
)

const RoadNetworkComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyRoadNetworkComponent />
  </SuspenseLoadingWrapper>
)

export const RoadNetworkArea = {
  id: RoadNetworkAreaId,
  requiredRight: BoumRight.AREA_ROAD_NETWORK,
  NavigationComponent: RoadNetworkAreaNavigation,
  route: {
    path: RoadNetworkAreaRoutes.route,
    component: RoadNetworkComponent,
  },
}
